/**
 * Copied: https://github.com/Uniswap/interface/blob/ad2472eac638b389316ba1f3c3f1ed08fbbb12cd/src/constants/chains.ts
 * Changed:
 * - Changed the set of supported chains (removed many)
 * - Added hardhat chain
 * - Removed distinction between L1 and L2 chains
 * - Moved `isSupportedChain` to src/util/supportedChainId.ts since it is not constant (environment dependent)
 * - Kept only information about chain names
 */

/**
 * List of all the networks supported by Swell Network
 */
export enum SupportedChainId {
  MAINNET = 1,
  GOERLI = 5,
  HARDHAT = 1337,
  SEPOLIA = 11155111,
  HOLESKY = 17000,
}

export const CHAIN_IDS_TO_NAMES = {
  [SupportedChainId.HARDHAT]: 'hardhat',
  [SupportedChainId.MAINNET]: 'mainnet',
  [SupportedChainId.GOERLI]: 'goerli',
  [SupportedChainId.SEPOLIA]: 'sepolia',
  [SupportedChainId.HOLESKY]: 'holesky',
}

export const getChainName = (chainId: number) => {
  return CHAIN_IDS_TO_NAMES[chainId as SupportedChainId]
}

export const CHAIN_IDS_TO_TITLE_NAMES = {
  [SupportedChainId.HARDHAT]: 'Hardhat',
  [SupportedChainId.MAINNET]: 'Ethereum Mainnet',
  [SupportedChainId.GOERLI]: 'Goerli Test Network',
  [SupportedChainId.SEPOLIA]: 'Sepolia Test Network',
  [SupportedChainId.HOLESKY]: 'Holesky Test Network',
}

export const getChainTitleName = (chainId: number) => {
  return CHAIN_IDS_TO_TITLE_NAMES[chainId as SupportedChainId]
}

export const ChainId = {
  MAINNET: SupportedChainId.MAINNET as number,
  GOERLI: SupportedChainId.GOERLI as number,
  HARDHAT: SupportedChainId.HARDHAT as number,
  SEPOLIA: SupportedChainId.SEPOLIA as number,
  HOLESKY: SupportedChainId.HOLESKY as number,

  // others
  ARBITRUM_ONE: 42161,
  BASE: 8453,
  BLAST: 81457,
  OPTIMISM: 10,
  STARKNET: -1,
  ZKSYNC: 324,
  BERACHAIN: -1,
  BERACHAIN_TESTNET: 80085,
  MONAD: -1,
  ZIRCUIT: 48900,
  ZIRCUIT_TESTNET: 48899,
  FRAXTAL: 252,
  CORE: 1116,
}
